// src/config/api.js
export const DEFAULT_URL = "https://ownli-prod-internal-api.azurewebsites.net";
//export const DEFAULT_URL = "https://ownli-prod-internal-api-stage.azurewebsites.net";
//export const DEFAULT_URL = "https://ownli-local-internal-api.azurewebsites.net"
//export const DEFAULT_URL = "https://ownli-dev-internal-api.azurewebsites.net"
//export const DEFAULT_URL = "http://localhost:8082";
//export const DEFAULT_URL = "http://localhost:8082";//"https://ownli-prod-internal-api-stage.azurewebsites.net";////"//https://ownli-dev-internal-api-stage.azurewebsites.net";////"https://040a-2406-7400-61-f7ac-20e8-3921-7986-dd67.ngrok-free.app";//"http://localhost:8082";"https://ownli-prod-internal-api.azurewebsites.net";"https://ownli-dev-internal-api.azurewebsites.net";//
const API_CONFIG = {
  // Base API URL with fallback chain:
  // 1. Use environment variable if set
  // 2. Fall back to local development server if not
  // 3. Final fallback to production URL
  BASE_URL:
    process.env.REACT_APP_API_BASE_URL || DEFAULT_URL || "https://api.ownli.co",

  // Helper function to build full API URL paths
  getUrl: function (path) {
    // Remove any leading slash from the path if present
    const cleanPath = path.startsWith("/") ? path.substring(1) : path;
    return `${this.BASE_URL}/${cleanPath}`;
  },

  // Common API endpoints
  ENDPOINTS: {
    // User endpoints
    USER: {
      GET_OR_CREATE: "api/users/get-or-create",
      PROFILE: "api/users/profile",
      CHECKINS: {
        INSURANCE_POLICY: "api/users/checkins/insurance-policy",
        EXPIRING_INSURANCE_POLICY:
          "api/users/checkins/insurance-policy/expiring",
      },
    },

    // Canopy Connect endpoints
    CANOPY: {
      CONNECTED_POLICY: "canopy-connect/checkins/connected-policy",
    },

    // Authentication endpoints
    AUTH: {
      VERIFY: "api/auth/verify",
    },
  },
};

export default API_CONFIG;
